var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.453 1.025a5.382 5.382 0 00-4.172 1.562 5.4 5.4 0 00-1.168 5.907c.125.3.056.647-.174.875L1.978 19.32a1.542 1.542 0 000 2.204c.618.616 1.59.616 2.208 0l9.969-9.942c.23-.231.577-.3.878-.175a5.424 5.424 0 005.917-1.166c1.136-1.134 1.659-2.686 1.51-4.262L19.78 8.658a.802.802 0 01-.796.202l-2.925-.84a.803.803 0 01-.55-.55l-.84-2.913a.8.8 0 01.2-.802l2.723-2.717a2.296 2.296 0 00-.138-.013zm1.105-.809l.12.032c.426.11.554.584.277.86l-3.281 3.276.777 2.694 2.698.776 3.282-3.276a.508.508 0 01.85.23c.578 2.213.004 4.535-1.613 6.15a6.44 6.44 0 01-6.893 1.438l-9.872 9.845a2.564 2.564 0 01-3.643 0 2.554 2.554 0 010-3.636l9.863-9.854A6.411 6.411 0 0117.52.014c.31.02.542.07 1.04.202zm.714 7.673a.177.177 0 00-.006-.002l.006.002z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgTools.displayName = 'Tools';
export default SvgTools;